import React, { useMemo } from "react";
import Loader from "../Common/Loader";
import { getFormattedNumber } from "../utils/textUtils";
import { Link } from "react-router-dom";

const IssueReport = ({ resPacket = [], loading }) => {
    const calcTotalWithTax = (row) => {
        const amount = parseFloat(row.itemRate) * Number(row.qty) || 0;
        return row.taxRate > 0
            ? ((parseFloat(row.taxRate) + 100) * amount) / 100
            : amount;
    };

    const totals = useMemo(
        () =>
            resPacket.reduce(
                (acc, row) => {
                    const amount = parseFloat(row.amount)|| 0
                    acc.amount += amount;
                    acc.total += parseFloat(row.taxAmount) || 0;
                    return acc;
                },
                { amount: 0, total: 0 }
            ),
        [resPacket]
    );

    if (loading) return <Loader />;
    if (resPacket.length === 0) return "No Records Found";

    return (
        <div className="customTable" id="scroll">
            <table className="customTable w-100">
                <thead className="fixed-thead">
                    <tr>
                        <td>SNO.</td>
                        <td>COST CENTER (DEPARTMENT)</td>
                        <td>ISSUANCE NUMBER</td>
                        <td>BATCH NO</td>
                        <td>MFG DATE</td>
                        <td>EXPIRY DATE</td>
                        <td>ITEM NAME</td>
                        <td>ITEM CATEGORY</td>
                        <td className="text-center">QTY</td>
                        <td>UOM</td>
                        <td>ITEM RATE</td>
                        <td>AMOUNT</td>
                        <td>TAX RATE</td>
                        <td>TOTAL AMOUNT</td>
                    </tr>
                </thead>
                <tbody className="body-scroll-custom">
                    {resPacket.map((row, i) => (
                        <tr key={row.issuanceUuid ?? i}>
                            <td>{i + 1}</td>
                            <td>{row.departMant}</td>
                            <td>
                                <Link
                                    to={`/issueitems/${row.issuanceUuid}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {row.grnNoBillNumber}
                                </Link>
                            </td>
                            <td>{row.batchNumber}</td>
                            <td>{row.mfgDate}</td>
                            <td>{row.expiryDate}</td>
                            <td>{row.itemName}</td>
                            <td>{row.category}</td>
                            <td className="text-right">{getFormattedNumber(row.qty)}</td>
                            <td>{row.uom}</td>
                            <td>{parseFloat(row.itemRate || 0).toFixed(3)}</td>
                            <td>
                                {(parseFloat(row.amount || 0)).toFixed(2) || 0}
                            </td>
                            <td>{row.taxRate}</td>
                            <td>{parseFloat(row?.taxAmount).toFixed(2)}</td>
                        </tr>
                    ))}
                    <tr className="total-row">
                        <td className="font-weight-bold">Totals</td>
                        <td className="font-weight-bold" colSpan={10}></td>
                        <td className="font-weight-bold">{totals.amount.toFixed(2)}</td>
                        <td className="font-weight-bold"></td>
                        <td className="font-weight-bold">{totals.total.toFixed(2)}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

export default IssueReport;
